import { jsx as _jsx } from "react/jsx-runtime";
import { RemovableCard } from '@dixa/lib-shared-habla';
import { PureComponent } from 'react';
import styles from '../bulkActionsModal.module.scss';
export class BulkActionsCancelCSAT extends PureComponent {
    render() {
        const { onRemove } = this.props;
        return (_jsx(RemovableCard, Object.assign({ className: styles.actionCard, icon: "close", title: "Cancel CSAT", onRemove: onRemove }, { children: _jsx("p", Object.assign({ className: styles.actionNote }, { children: "Please note that, once CSAT has been cancelled it cannot be reinstated. Please select this option only if you are sure you would like to cancel CSAT for the selected conversations. If selected conversations are not eligible for CSAT, they will not be affected." })) })));
    }
}
